import React, { Component } from 'react';

import '../../../../../chat.css';

/**
 * A message type that shows a html encoded text message.
 */
class TextMessage extends Component {
    render() {
        return(
            <div className={'text-message-container'}>
                <div dangerouslySetInnerHTML={{__html: this.props.content}}></div>
            </div>
        );
    }
}

export default TextMessage;
